import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {pullRequestsLayoutRoute} from '../routes/layout-route'
import {useInvalidateOnAliveUpdate} from './use-invalidate-on-alive-update'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.tab_counts_updated)

/**
 * Subscribe to live updates for tab counts.
 */
export function useTabCountLiveUpdates() {
  const {
    data: {aliveChannels},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  const {queryKey: tabCountsQueryKey, refetch: refetchTabCounts} = useRouteQuery(pullRequestsLayoutRoute, 'tabCounts')
  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')

  // (flag on): deduped invalidate on alive update
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? aliveChannels.pullRequest : '', tabCountsQueryKey, {
    filter,
  })

  // (flag off): refetch on alive update
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : aliveChannels.pullRequest, refetchTabCounts, {
    tab_counts_updated: true,
  })
}
